/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "clientPortalLogAPI",
            "endpoint": "https://0p9a1xgmvb.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "getEmbedUrlAPI",
            "endpoint": "https://6fclt40ob5.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "getUserServerConfigsAPI",
            "endpoint": "https://xupvltlixe.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "resetLookBackStartDateGAAPI",
            "endpoint": "https://3apjcsvzp2.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "tripQueryAPI",
            "endpoint": "https://dlxlxatboh.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "userQueryAPI",
            "endpoint": "https://21rud1q8ie.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "userViolationQueryAPI",
            "endpoint": "https://tuswzzsyp2.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:694f9d8d-2872-4b3e-9ea1-b7ceb5c7866f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_4TzJhhxi2",
    "aws_user_pools_web_client_id": "21ff5k7g6qcsjasghevpoitg6a",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Vehicle_table",
            "region": "us-east-1"
        },
        {
            "tableName": "Vehicle_table",
            "region": "us-east-1"
        },
        {
            "tableName": "statistics_regions",
            "region": "us-east-1"
        },
        {
            "tableName": "statistics_regions",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
